import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/edit.svg'
import _imports_2 from '@/assets/img/infoIcon.png'
import _imports_3 from '@/assets/img/management/search.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-918d7120")

_pushScopeId("data-v-918d7120")
const _hoisted_1 = { class: "fixedViewOverLayout hasHeader genericPadding" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "sideContainer"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "greyBlue d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  src: _imports_2,
  class: "ms-2",
  style: {"width":"16px"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "shipment mt-0" }
const _hoisted_12 = { class: "greyBlue" }
const _hoisted_13 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_14 = {
  key: 0,
  src: _imports_3,
  class: "me-2"
}
const _hoisted_15 = {
  key: 2,
  src: _imports_1,
  class: "me-2"
}
const _hoisted_16 = {
  key: 3,
  class: "fs_14 d-block ln_12"
}
const _hoisted_17 = { class: "mb-3 d-flex align-items-start" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "me-2"
}, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "fs_14 d-block ln_12"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "mt-5 text-center" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = {
  key: 0,
  class: "greyBlue pagamento"
}
const _hoisted_24 = {
  key: 1,
  class: "xPayForm mt-5"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "input-form" }, [
  /*#__PURE__*/_createVNode("div", { id: "xpay-card" })
], -1)
const _hoisted_26 = { class: "text-center text-danger" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", {
  id: "xpay-btn",
  class: "d-none"
}, null, -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  style: {"margin":"15px 0","font-weight":"700"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_cart_item = _resolveComponent("cart-item")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_13 greyBlue",
        localizedKey: "app_carrello",
        text: "Carrello"
      }),
      (_ctx.model.cartItems.length > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "sideContainer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSettings()))
          }, [
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5))
    ]),
    (_ctx.model.cartItems.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_iltuocarrelloevuoto",
          text: "Il tuo carrello è vuoto",
          class: "fs_14 greyBlue d-block ln_12 mt-5 text-center"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.cartItems, (cartItem, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "mb-3",
              key: index
            }, [
              _createVNode(_component_cart_item, {
                model: cartItem,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openSettings()))
              }, null, 8, ["model"])
            ]))
          }), 128)),
          _createVNode("div", {
            class: "shipment mb-0",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.shipmentDetail()))
          }, [
            _createVNode("h4", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: 'app_spedizione',
                text: 'Spedizione'
              }),
              (_ctx.model.shipmentDescription)
                ? (_openBlock(), _createBlock("img", _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            (_ctx.model.shipmentAmount > 0)
              ? (_openBlock(), _createBlock("h4", _hoisted_9, [
                  _createVNode("span", null, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.model.shipmentAmount)), 1)
                ]))
              : (_openBlock(), _createBlock("h4", _hoisted_10, [
                  _createVNode(_component_localized_text, {
                    localizedKey: 'app_gratuita',
                    text: 'Gratuita'
                  })
                ]))
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("h4", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: 'app_totale',
                text: 'Totale'
              })
            ]),
            _createVNode("h4", null, [
              _createVNode("span", null, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.model.totalPrice)), 1)
            ])
          ]),
          (_ctx.hasShippableItem)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode(_component_localized_text, {
                  class: "fs_12 greyBlue d-block mt-2 mb-2",
                  localizedKey: "app_indirizzodiconsegna",
                  text: "Indirizzo di consegna"
                }),
                _createVNode("div", {
                  class: "mb-3 d-flex align-items-center",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchCity()))
                }, [
                  (!_ctx.model.shippingAddress)
                    ? (_openBlock(), _createBlock("img", _hoisted_14))
                    : _createCommentVNode("", true),
                  (!_ctx.model.shippingAddress)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "app_selezionaunindirizzo",
                        text: "Seleziona un'indirizzo",
                        class: "fs_14"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.model.shippingAddress)
                    ? (_openBlock(), _createBlock("img", _hoisted_15))
                    : _createCommentVNode("", true),
                  (_ctx.model.shippingAddress && _ctx.model.shippingAddress.typedAddress)
                    ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.model.shippingAddress.typedAddress), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: "mb-4",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSettings()))
          }, [
            _createVNode(_component_localized_text, {
              class: "fs_12 greyBlue d-block mt-2 mb-2",
              localizedKey: "app_note",
              text: "Note:"
            }),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              (_ctx.model.notes)
                ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.model.notes), 1))
                : (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    localizedKey: "app_inseriscidellenoterelativeallordine",
                    text: "Inserisci delle note relative all'ordine",
                    class: "fs_14"
                  }))
            ])
          ]),
          _createVNode("div", null, [
            (_ctx.hasShippableItem && !_ctx.model.shippingAddress)
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "app_inserisciunindirizzodiconsegnaprimadiproseguire",
                    text: "inserisci un indirizzo di consegna prima di proseguire",
                    class: "fs_14 orange text-center d-block ln_12 mt-5"
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                (_ctx.model.xPayApiKey != null || '')
                  ? (_openBlock(), _createBlock("h4", _hoisted_23, [
                      _createVNode(_component_localized_text, {
                        localizedKey: 'app_inserisciCarta:',
                        text: 'Inserisci i dati della carta:'
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.model.xPayApiKey)
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode("div", _hoisted_26, _toDisplayString(_ctx.errors), 1),
                      _hoisted_27
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loaded)
                ? (_openBlock(), _createBlock("div", _hoisted_28, [
                    (_ctx.model.xPayApiKey)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          id: "pagaBtn",
                          class: " genericButton squareGenericButton mr-1 w-100",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pagaBtn())),
                          disabled: !_ctx.paymentLoading || _ctx.isDisabled
                        }, [
                          _createVNode(_component_localized_text, {
                            class: "fs_13 text-uppercase white",
                            localizedKey: "app_pagaora",
                            text: "Paga ora"
                          })
                        ], 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.model.xPayApiKey)
                      ? (_openBlock(), _createBlock("p", _hoisted_29, [
                          _createVNode(_component_localized_text, {
                            localizedKey: 'app_oppure',
                            text: 'Oppure'
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", {
                class: "genericButton squareGenericButton w-100",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createOrderWireTranfer())),
                disabled: _ctx.isDisabled
              }, [
                _createVNode(_component_localized_text, {
                  class: "fs_13 text-uppercase white",
                  localizedKey: "app_pagaconbonifico",
                  text: "Paga con bonifico"
                })
              ], 8, ["disabled"])
            ])
          ])
        ]))
  ]))
})